import React from 'react';
import { PublicFieldProps, InjectedFieldProps, Record } from 'react-admin';
import { dateWithoutServerTimezone } from '../utils/dateWithoutServerTimezone';

type WithoutTimezoneDateFieldProps = PublicFieldProps &
  InjectedFieldProps<Record>;

export const WithoutTimezoneDateField = (
  props: WithoutTimezoneDateFieldProps,
) => {
  if (!props.record || !props.source || !props.record[props.source])
    return null;
  const dateFormatted = dateWithoutServerTimezone(props.record[props.source]);

  return (
    <>
      <label>{`${
        dateFormatted.getMonth() + 1
      }/${dateFormatted.getDate()}/${dateFormatted.getFullYear()}`}</label>
    </>
  );
};

export default WithoutTimezoneDateField;
